import * as tslib_1 from "tslib";
import { SystemMessagesApi } from '../api/system-message-api';
import * as i0 from "@angular/core";
import * as i1 from "../api/system-message-api";
var padSize = 2;
var SystemMessagesService = /** @class */ (function () {
    function SystemMessagesService(api) {
        this.api = api;
    }
    SystemMessagesService.prototype.pad = function (ret, num, str) {
        if (str === void 0) { str = '0'; }
        return ret.padStart(num, str).slice(-num);
    };
    SystemMessagesService.prototype.dateString = function (date) {
        return date.getFullYear() + "-" + this.pad((date.getMonth() + 1).toString(), padSize) + "-" + this.pad(date.getDate().toString(), padSize) + "T" + this.pad(date.getHours().toString(), padSize) + ":" + this.pad(date.getMinutes().toString(), padSize) + ":" + this.pad(date.getSeconds().toString(), padSize);
    };
    SystemMessagesService.prototype.fixDates = function (message) {
        if (message) {
            if (message.startDate && typeof message.startDate !== 'string') {
                message.startDate = this.dateString(message.startDate);
            }
            if (message.expirationDate && typeof message.expirationDate !== 'string') {
                message.expirationDate = this.dateString(message.expirationDate);
            }
        }
        return message;
    };
    SystemMessagesService.prototype.getAllMessages = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.getSystemMessages()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SystemMessagesService.prototype.deleteSystemMessage = function (systemMessageId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.deleteSystemMessage(systemMessageId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SystemMessagesService.prototype.createSystemMessage = function (systemMessage, userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        systemMessage.id = 0;
                        systemMessage = this.cleanDataObjectForSave(systemMessage);
                        return [4 /*yield*/, this.api.saveSystemMessage(this.fixDates(systemMessage), userId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SystemMessagesService.prototype.saveSystemMessage = function (systemMessage, userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        systemMessage = this.cleanDataObjectForSave(systemMessage);
                        return [4 /*yield*/, this.api.saveSystemMessage(this.fixDates(systemMessage), userId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SystemMessagesService.prototype.getUserMessageInbox = function (userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.getUserSystemMessageStatus(userId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SystemMessagesService.prototype.markUserMessageRead = function (userId, systemMessageId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.saveUserSystemMessageStatus(systemMessageId, userId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SystemMessagesService.prototype.markUserMessageDismissed = function (userId, systemMessageId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.saveUserSystemMessageStatus(systemMessageId, userId, true)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SystemMessagesService.prototype.getSystemCategories = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.getSystemMessageCategories()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SystemMessagesService.prototype.cleanDataObjectForSave = function (message) {
        if (message) {
            var cleanedMessage = tslib_1.__assign({}, message);
            delete cleanedMessage.createDate;
            delete cleanedMessage.systemMessageCategory;
            return cleanedMessage;
        }
        return message;
    };
    SystemMessagesService.ngInjectableDef = i0.defineInjectable({ factory: function SystemMessagesService_Factory() { return new SystemMessagesService(i0.inject(i1.SystemMessagesApi)); }, token: SystemMessagesService, providedIn: "root" });
    return SystemMessagesService;
}());
export { SystemMessagesService };
